function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { Divider } from "./chunk-ILA4CZTR.mjs";
import { jsx } from "./chunk-EBMUSV7F.mjs";
import { neutralDay } from "./chunk-6NWZQNAN.mjs";
// src/components/Divider/Divider.tsx
import { forwardRef } from "react";
var DEFAULT_ORIENTATION = "horizontal";
var Divider2 = forwardRef(function Divider3(_param, ref) {
    var as = _param.as, _param_size = _param.size, size = _param_size === void 0 ? 1 : _param_size, _param_color = _param.color, color = _param_color === void 0 ? neutralDay.gray90 : _param_color, _param_decorative = _param.decorative, decorative = _param_decorative === void 0 ? false : _param_decorative, _param_orientation = _param.orientation, orientation = _param_orientation === void 0 ? DEFAULT_ORIENTATION : _param_orientation, _param_isFlexItem = _param.isFlexItem, isFlexItem = _param_isFlexItem === void 0 ? false : _param_isFlexItem, restProps = _object_without_properties(_param, [
        "as",
        "size",
        "color",
        "decorative",
        "orientation",
        "isFlexItem"
    ]);
    var semanticProps = decorative ? {
        role: "none"
    } : {
        role: "separator",
        "aria-orientation": orientation
    };
    return /* @__PURE__ */ jsx(Divider, _object_spread({
        as: as,
        ref: ref,
        size: size,
        color: color,
        orientation: orientation,
        isFlexItem: isFlexItem
    }, semanticProps, restProps));
});
export { Divider2 as Divider };
